import { Component, ElementRef, OnInit, TemplateRef, ViewChild, ChangeDetectorRef, NgZone } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxOtpInputComponentOptions } from 'ngx-otp-input';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EnkashCardsService } from '@app-service/enkash-cards.service';
import { Subscription } from "rxjs";
import { UserService } from '@app-service/user.service';
import { ToasterService, ToasterType } from '@app-service/toaster.service';
import { RequestState } from '@app-common/http/RequestState';

@Component({
    selector: 'app-cobranded-tnc',
    templateUrl: './cobranded-tnc.component.html',
    styleUrls: ['./cobranded-tnc.component.scss'],
    standalone: false
})
export class CobrandedTncComponent implements OnInit {

  otpInputConfig: NgxOtpInputComponentOptions = {
    otpLength: 6,
    autoFocus: true,
    inputMode: 'numeric',
    autoBlur: true, 
    hideInputValues: false,
    showBlinkingCursor: true,
    ariaLabels: ['OTP Input'],
  };

  walletId: string;
  token: string;
  redirectUrl: string;
  otpRendered: boolean;
  tncAccepted: boolean;
  tncVersionMasterId: string;
  otpRequestId: string;
  minKycOtpVerified: boolean;
  showTnc: boolean = false;

  verifyOtpPending = RequestState.init();

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
  isAgreeEnabled: boolean = false;
  private SCROLL_TOLERANCE = 1;

  @ViewChild('otpModal') otpModal!: TemplateRef<any>;
  modalRef: any;

  timeLeft: number = 60;
  interval: any;
  resendOTPStatus: boolean = true;
  showOtpScreen: boolean = false;
  otpVisible: boolean = true;
  otpInputKey: number = 0;
  mobileNumber: string;

  private subscription: Subscription = new Subscription();

  constructor(
    private modalService: BsModalService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private enkashCardService: EnkashCardsService,
    private userService: UserService,
    private toasterService: ToasterService
  ) { }

  otpControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^\d{0,6}$/)  // allow only digits, max 6
  ]);

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      let base64WalletId = params['WID'];
      let base64token = params['at'];
      let redirectUrl = params['returnUrl'];

      if (base64WalletId) {
        this.walletId = atob(base64WalletId);
      }

      if (base64token) {
        this.token = atob(base64token);
      }

      // this.redirectUrl = redirectUrl;

      if (redirectUrl) {
        this.redirectUrl = atob(redirectUrl);
      }

      this.fetchCardDetails();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  fetchCardDetails() {
    this.subscription.add(
      this.enkashCardService.getCardDetailsByPartnerId(this.walletId, this.token)
        .subscribe(
          res => {
            this.otpRendered = res.payload.partnerOtpRender;
            this.tncAccepted = res.payload.latestTnCVersionAccepted;
            this.minKycOtpVerified = res.payload.minKycOtpVerified;
            this.tncVersionMasterId = res.payload.tncVersionMasterId;
            this.mobileNumber = res.payload.mobile;

            if (this.tncAccepted && this.minKycOtpVerified) {
              this.showTnc = false;
              this.redirectToPartnerUrl();
              return;
            }
            else if (this.tncAccepted && !this.minKycOtpVerified) {
              this.showTnc = false;
              if (this.otpRendered) {
                if (this.isMobile()) {
                  this.showOtpScreenForMobile();
                } else {
                  this.openInfoModal(this.otpModal);
                }
              }
              else {
                this.redirectToPartnerUrl();
                return;
              }
            }
            else {
              this.showTnc = true;
            }
          },
          error => {
            const errorJson = error.error;
            let errorMsg = '';
            if (errorJson && errorJson.response_message) {
              errorMsg = errorJson.response_message;
            } else {
              errorMsg = "Something went wrong!";
            }
            this.toasterService.showToaster(errorMsg, ToasterType.ERROR);
          }
        )
    );
  }

  redirectToPartnerUrl(accept?: boolean) {
    if (accept !== undefined) {
      const separator = this.redirectUrl.includes('?') ? '&' : '?';
      window.location.href = `${this.redirectUrl}${separator}accept=${accept}`;
    } else {
      window.location.href = this.redirectUrl;
    }
  }

  isMobile(): boolean {
    return (window.innerWidth <= 768);
  }

  onScroll(event: any): void {
    const el = event.target as HTMLElement;
    const scrolledToBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
    this.isAgreeEnabled = scrolledToBottom;
  }

  private openOtpModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'app-modal-container',
    });

    this.startTimer();
    this.sendOtp();
  }

  private showMobileOtpScreen() {
    this.showOtpScreen = true;
    this.otpVisible = true;
    this.startTimer();
    this.sendOtp();
  }

  openInfoModal(template: TemplateRef<any>) {
    // this.subscription.add(
    //   this.userService.getUserDetails(this.token).subscribe(
    //     (userResponse) => {
    //       const currentUser = userResponse['payload'];
    //       this.mobileNumber = currentUser.mobile_number;
    //       this.openOtpModal(template);
    //     },
    //     (error) => {
    //       this.mobileNumber = 'XXXXXXXXXX';
    //       this.openOtpModal(template);
    //     }
    //   )
    // );
    this.openOtpModal(template);
  }

  showOtpScreenForMobile() {
    // this.subscription.add(
    //   this.userService.getUserDetails(this.token).subscribe(
    //     (userResponse) => {
    //       const currentUser = userResponse['payload'];
    //       this.mobileNumber = currentUser.mobile_number;
    //       this.showMobileOtpScreen();
    //     },
    //     (error) => {
    //       this.mobileNumber = 'XXXXXXXXXX';
    //       this.showMobileOtpScreen();
    //     }
    //   )
    // );
    this.showMobileOtpScreen();
  }

  sendOtp() {
    this.subscription.add(
      this.enkashCardService.sendOtpForPpiMinKyc(this.walletId, 'ACTIVATE', this.token)
        .subscribe(
          (res) => {
            this.otpRequestId = res.otpRequestId;
            this.toasterService.showToaster('OTP sent successfully', ToasterType.SUCCESS);
          },
          (error) => {
            const errorJson = error.error;
            let errorMsg = '';
            if (errorJson && errorJson.response_message) {
              errorMsg = errorJson.response_message;
            } else {
              errorMsg = "Error sending OTP";
            }
            this.toasterService.showToaster(errorMsg, ToasterType.ERROR);
          }
        )
    );
  }

  onAgreeClick() {
    this.subscription.add(
      this.userService.getUserDetails(this.token).subscribe(
        (userResponse) => {
          const currentUser = userResponse['payload'];

          const payload = {
            tncVersionMasterId: this.tncVersionMasterId,
            cardTncAcceptedType: 'CARD_TNC',
            enKashCardId: this.walletId,
            ekUserId: currentUser.ek_user_id
          };

          this.acceptTnc(payload);
        }
      )
    );
  }

  acceptTnc(payload: any) {
    this.subscription.add(
      this.enkashCardService.acceptPpiTnc(payload, this.token)
        .subscribe(
          (res) => {
            if (this.otpRendered) {
              if (this.isMobile()) {
                this.showOtpScreenForMobile();
              } else {
                this.openInfoModal(this.otpModal);
              }
            }
            else {
              this.redirectToPartnerUrl();
            }
          },
          (error) => {
            const errorJson = error.error;
            let errorMsg = '';
            if (errorJson && errorJson.response_message) {
              errorMsg = errorJson.response_message;
            } else {
              errorMsg = "TnC Acceptance failed!";
            }
            this.toasterService.showToaster(errorMsg, ToasterType.ERROR);
          }
        )
    );
  }

  verifyOtp() {
    const otp = this.otpControl.value;

    if (!otp || otp.length !== 6 || this.verifyOtpPending.isPending()) {
      return;
    }

    this.verifyOtpPending.pending();

    this.subscription.add(
      this.enkashCardService
        .verifyMinKyc(this.walletId, this.otpRequestId, otp, this.token, false)
        .subscribe(
          (res) => {
            this.verifyOtpPending.completed();
            if (this.modalRef) {
              this.modalRef.hide();
            }
            this.showOtpScreen = false;
            this.redirectToPartnerUrl(true);
            return;
          },
          (err) => {
            this.verifyOtpPending.rejected();
            const errorJson = err.error;
            let errorMsg = '';
            if (errorJson && errorJson.response_message) {
              errorMsg = errorJson.response_message;
            } else {
              errorMsg = "Error verifying OTP";
            }
            this.toasterService.showToaster(errorMsg, ToasterType.ERROR);
          }
        )
    );
  }

  closeInfoModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.clearTimer();
    this.otpControl.reset('');
    this.otpInputKey++;
    this.redirectToPartnerUrl(false);
  }

  onOtpChange(event: any): void {
    const otpValue = event.target.value;
    const isValidOtp = /^\d{0,6}$/.test(otpValue);

    if (isValidOtp) {
      this.otpControl.setValue(otpValue);
    } else {
      event.target.value = this.otpControl.value;
    }
  }

  onMobileOtpChange(otp: string): void {
    const otpValue = Array.isArray(otp) ? otp.join('') : otp;
    this.otpControl.setValue(otpValue);
    this.otpControl.markAsTouched();
    this.otpControl.updateValueAndValidity();
  }

  startTimer(): void {
    this.clearTimer();
    this.timeLeft = 60;
    this.resendOTPStatus = true;

    this.ngZone.run(() => {
      this.interval = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.clearTimer();
          this.resendOTPStatus = false;
        }

        this.cdr.detectChanges();
      }, 1000);
    });
  }

  clearTimer(): void {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  resendOtp(): void {
    this.startTimer();
    this.otpControl.reset('');
    this.otpInputKey++;
    this.sendOtp();
  }

  goBack(): void {
    this.location.back();
  }

  goToTnc(): void {
    this.redirectToPartnerUrl(false);
  }
}
